// Hardcoded fallback event — FutureX Design Challenge 2026.
// Used automatically when the database has no events in this category yet.

export const SPECIAL_EVENTS_FALLBACK = [
  {
    id: 'world-science-day-lecture-2026',
    category: 'Distinguished Lecture',
    title: 'Distinguished Lecture: Computing for Peace and Sustainable Development — Ts. Dr. Thamil Vaani Arvaree',
    description: `The Department of Basic Science and Humanities, Institute of Engineering & Management, Salt Lake, organizes a Distinguished Lecture in collaboration with the IEM Society of Physics Students Chapter, an organisation of the American Institute of Physics, and the Rotary Club of Salt Lake Silicon Valley.

Theme: World Science Day (Peace and Development)

Lecture Topic: Computing for Peace and Sustainable Development: Turning Science into Solutions for People and Planet

Speaker: Ts. Dr. Thamil Vaani Arvaree, Assistant Professor, University of Nottingham Malaysia

Date: 10th November 2026 (Tuesday)
Time: 11:00 AM
Mode: Online via Zoom
Meeting ID: 489 740 6939 | Passcode: 315321
First Come First Serve.

Chief Patron: Prof. Prabir Kumar Das
Patron: Prof. Ranabir Banik, Prof. Samapika Das Biswas
Session Chair: Prof. Biswadip Basu Mallik
Faculty Coordinator: Prof. Debasmita Bhattacharya
Organiser Team: Prof. Soumyadipta Pal, Prof. Amit Nandi, Prof. Sayan Paul`,
    date: '2026-11-10',
    imageUrl: '/world-science-day-lecture-2026-flyer.jpeg',
    links: [
      { label: 'Join via Zoom', url: 'https://us06web.zoom.us/j/4897406939?pwd=Vgb321qqGzsbdNyslqmAvnFibdPQRt.1' },
    ],
    linkUrl: '/world-science-day-lecture-2026-flyer.jpeg',
  },
  {
    id: 'iematics-2026',
    category: 'Competition',
    title: 'IEMATICS — 9th Online International Mathematics Olympiad 2026',
    description: `We are very proud to announce that the Society for Makers, Artists, Researchers and Technologists (SMART), USA presents IEMATICS — the Ninth Online International Mathematics Olympiad, sponsored by Institute of Engineering & Management (IEM) in association with the Department of Basic Science and Humanities, IEM, Kolkata and the Society for Data Science (S4DS) IEM Student Chapter.

Students and Mathematics lovers from different spheres are cordially welcomed.

Event date: 31st October 2026
Time: The online contest starts at 7:00 PM IST and closes at 10:00 PM IST on the day of the contest.
Registration: Participation is free of cost.

Participants need to register through the registration link provided on the website and should participate in the contest through the contest link at 7:00 PM IST on 31st October 2026.

Prizes worth 300 USD will be given to the top 3 participants along with a certificate of excellence. Participants who solve at least three questions will get a certificate of merit.

For detailed information, visit https://iematics.smartsociety.org/`,
    date: '2026-10-31',
    imageUrl: '/iematics-2026-flyer.jpeg',
    links: [
      { label: 'Register / Visit IEMATICS Website', url: 'https://iematics.smartsociety.org/' },
    ],
    linkUrl: '/iematics-2026-flyer.jpeg',
  },
  {
    id: 'raman-distinguished-lecture-2026',
    category: 'Talk',
    title: 'Online Distinguished Lecture Commemorating the Birthday of Sir C. V. Raman',
    description: `The Department of Basic Science and Humanities, IEM Salt Lake, Kolkata, organizes an online distinguished lecture celebrating the legacy of Nobel Laureate Sir C. V. Raman.

Talk: Enhancing Raman Spectroscopy: From Molecular Fingerprinting to Chirality Detection

Speaker: Dr. Debraj Gangopadhyay
Associate Scientist, Institute of Organic Chemistry and Biochemistry, Prague, Czech Republic

Date: Saturday, 7 November 2026
Time: 2:00 PM IST onwards
Mode: Online via Google Meet
Please register yourself.

Participation certificates (with MAR points) will be awarded to attendees present throughout the session.

Faculty Coordinators:
Dr. Subhadip Chakraborty — 9830887841
Dr. Sangeeta Das — 9038045206
Dr. Saheli Sengupta — 6290914264
Dr. Anisha Purkait — 9903854630`,
    date: '2026-11-07',
    imageUrl: '/raman-distinguished-lecture-2026-flyer.jpeg',
    links: [
      { label: 'Register Here', url: 'https://forms.gle/dLPWYTjhHYaVP97A9' },
      { label: 'Join on Google Meet', url: 'https://meet.google.com/gsq-ibuf-kxn?hs=224' },
    ],
    linkUrl: '/raman-distinguished-lecture-2026-flyer.jpeg',
  },
  {
    id: 'mission-moon-lunar-base-design-challenge-2026',
    category: 'Celebration',
    title: 'National Space Day Celebration 2026 — Mission Moon: Lunar Base Design Challenge',
    description: `CoE IIFR Lab, IIC IEM and the Department of Basic Science and Humanities presented the National Space Day Celebration 2026 — Mission Moon: Lunar Base Design Challenge.

Participants had to design a lunar base that addresses energy, water, oxygen, food, communication and waste management.

Date of submission start: 16th August 2026
Last date of submission: 20th August 2026
Result announcement: 24th August 2026

Certificate for all (will carry MAR points and will make your CV strong).
Awards for the Winner and the 1st and 2nd Runner Up.

Why participate? Real-world problem solving; innovate for the future; enhance your skills and portfolio; make your CV stand out; be a part of India's space vision.

The winners of this challenge, together with those of the FutureX Design Challenge and the Inter Section Business Plan Competition, received their certificates at the Certificate Distribution Ceremony on 8th October 2026 (photographs below).

Organizers: Dr. Chandan Adhikari, Dr. Ranabir Banik, Dr. Somnath Roy, Dr. Sukhendu Sadhukhan
Organizing Chair: Dr. Prabir Kumar Das
Student Coordinators: Debasish Mohanty, Subarna De, Soumik Nath, Ankush Banerjee, Sounak Chakrabarty

Dream Big. Design Bold. Build the Future Beyond Earth!`,
    date: '2026-10-08',
    imageUrl: '/mission-moon-2026-1.jpeg',
    images: [
      '/mission-moon-2026-1.jpeg',
      '/mission-moon-2026-2.jpeg',
      '/mission-moon-2026-3.jpeg',
      '/mission-moon-2026-4.jpeg',
      '/mission-moon-2026-5.jpeg',
    ],
    linkUrl: '/mission-moon-2026-flyer.jpeg',
  },
  {
    id: 'big-green-durga-2026',
    category: 'Celebration',
    title: 'BIG Green Durga 2026 @ IEM',
    description: `The Department of Basic Science and Humanities, IEM Salt Lake, in association with 92.7 BIG FM, successfully organised a vibrant celebration of Durga Puja, culture and sustainability on 22nd September 2026.

Green Choices, Brighter Tomorrows.

Date: 22nd September 2026
Time: 5:00 PM – 6:30 PM
Venue: IEM Salt Lake Management House

With 400+ enthusiastic students participating in song, recitation, dance, quizzes and other talent activities, the event beautifully brought together tradition, creativity and the Go Green spirit.

Activities: Quizzes and Puja-themed challenges; Green Durga and sustainability activities; Music; Talent-based activities; Photo/selfie zone; Giveaways, prizes and much more.

Heartfelt thanks to the IEM-UEM Group for encouraging and supporting such meaningful initiatives.

Organised by: Prof. Dr. Samapika Das Biswas, Prof. Dr. Sourav Adhikary, Prof. Dr. Souvik Mondal, Prof. Dr. Saheli Sengupta, Prof. Dr. Subhadip Chakraborty

Celebrate | Create | Connect | Go Green`,
    date: '2026-09-22',
    venue: 'IEM Salt Lake Management House',
    imageUrl: '/big-green-durga-2026-1.jpeg',
    images: [
      '/big-green-durga-2026-1.jpeg',
    ],
    linkUrl: '/big-green-durga-2026-flyer.jpeg',
  },
  {
    id: 'drone-assembly-workshop-2026',
    category: 'Workshop',
    title: 'Drone Assembly and Flight Control',
    description: `IIFR Lab, IIC IEM and the Department of Basic Science and Humanities presented a hands-on workshop exclusively for B.Tech. students: Drone Assembly and Flight Control.

Understand how individual components work together to achieve stable and controlled flight.

Topics: Drone Components and Assembly; Electronics and Wiring; Flight Control and Calibration; Hands-on Practice and Flight Testing.

Instructor: Pratim Chaterjee, DGCA approved Drone Instructor, Former U.A.V. Engineer and Instructor.

Date & Time: 14th October 2026 (Wednesday), 4:15 PM to 5:30 PM
Venue: CII Auditorium, IEM Management House
Seats: Limited, only 80
Certificate: Certificate for all participants (will carry MAR points)
Mandatory requirement: Participants needed to bring their own laptop.

Organizers: Dr. Chandan Adhikari, Dr. Sukhendu Sadhukhan, Dr. Somnath Roy, Dr. Ranabir Banik, Shivam Roy Chowdhury
Organizing Chair: Dr. Prabir Kumar Das`,
    date: '2026-10-14',
    imageUrl: '/drone-assembly-workshop-2026-1.jpeg',
    images: [
      '/drone-assembly-workshop-2026-1.jpeg',
      '/drone-assembly-workshop-2026-2.jpeg',
      '/drone-assembly-workshop-2026-3.jpeg',
      '/drone-assembly-workshop-2026-4.jpeg',
      '/drone-assembly-workshop-2026-5.jpeg',
      '/drone-assembly-workshop-2026-6.jpeg',
    ],
    linkUrl: '/drone-assembly-workshop-2026-flyer.jpeg',
  },
  {
    id: 'world-entrepreneurs-day-2026',
    category: 'Talk',
    title: 'World Entrepreneurs’ Day 2026 — Talk by Dr. Mita Tarafder',
    description: `The Department of Basic Science and Humanities, IEM Kolkata, in association with IIC-IEM, successfully organized an online program on World Entrepreneurs’ Day 2026 featuring Dr. Mita Tarafder (Chief Scientist (Retd.), CSIR-NML and renowned social entrepreneur) as the eminent speaker.

Theme: Innovation • Resilience • Inclusive Growth

The event witnessed enthusiastic participation from students, making the session highly interactive and inspiring.

Date & Time: Friday, 21st August 2026, 7 PM onwards
Mode: Online programme

About the Speaker: Dr. Mita Tarafder is Chief Scientist (Retd.), CSIR-National Metallurgical Laboratory (NML) and Professor of AcSIR (2012). She is Founder Trustee of the Relearn Foundation, which promotes education for underprivileged students, and a Mentor for Capacity Building for Design and Entrepreneurship at IIEST, Shibpur. She is a distinguished leader in science, innovation and social entrepreneurship.

Key Highlights: Insights on Innovation and Entrepreneurship; Building a Sustainable and Inclusive Future; Role of Science & Technology in Social Progress.

We sincerely thank Dr. Mita Tarafder for her valuable insights and the IEM-UEM Group for the continued support.

Faculty Coordinators: Dr. Subhadip Chakraborty, Dr. Sudip Jana, Dr. Jeet Sen`,
    date: '2026-08-21',
    imageUrl: '/world-entrepreneurs-day-2026-1.jpeg',
    images: [
      '/world-entrepreneurs-day-2026-1.jpeg',
    ],
    linkUrl: '/world-entrepreneurs-day-2026-flyer.jpeg',
  },
  {
    id: 'smart-system-workshop-2026',
    category: 'Workshop',
    title: 'Build Your First Smart System — Explore Sensors, Actuators & Automation',
    description: `IIFR Lab, IIC IEM and the Department of Basic Science and Humanities presented a hands-on workshop exclusively for B.Tech. first-year students: Build Your First Smart System — Explore Sensors, Actuators & Automation.

Learn. Experiment. Build. Innovate. From Components to Real-World Applications.

Sensors: Read the World. Actuators: Make Things Move. Automation: Bring Ideas to Life.

Date & Time: 6th October 2026, 4:30 PM to 5:30 PM
Venue: CII Auditorium, IEM Management House
Instructor: Shivam Roy Chowdhury
Seats: Limited, only 100
Certificate: Certificate for all (will carry MAR points)
Mandatory requirement: Participants needed to bring their own laptop and the Arduino Kit given by IEM.

Organizers: Dr. Chandan Adhikari, Dr. Ranabir Banik, Dr. Somnath Roy, Dr. Sukhendu Sadhukhan
Organizing Chair: Dr. Prabir Kumar Das

Hands-on Learning. Real Skills. Brighter Future. Let's Build a Smarter Tomorrow!`,
    date: '2026-10-06',
    imageUrl: '/smart-system-workshop-2026-1.jpeg',
    images: [
      '/smart-system-workshop-2026-1.jpeg',
      '/smart-system-workshop-2026-2.jpeg',
      '/smart-system-workshop-2026-3.jpeg',
      '/smart-system-workshop-2026-4.jpeg',
    ],
    linkUrl: '/smart-system-workshop-2026-flyer.jpeg',
  },
  {
    id: 'ieee-embs-installation-2026',
    category: 'Clubs & Student Chapters',
    title: 'Installation of the IEEE Engineering in Medicine and Biology Society (EMBS) Student Branch Chapter',
    description: `The IEEE Engineering in Medicine and Biology Society (EMBS) Student Branch Chapter was installed at the Institute of Engineering & Management (IEM), Kolkata, under the IEEE Kolkata Section, on 12th October 2026 (4:15 PM onwards).

The installation ceremony featured the ceremonial lamp lighting, IEEE Day celebration and a poster presentation session by students.

Distinguished Guests

We were honoured by the presence of:

• Dr. Susanta Ray — Professor, Department of Electrical Engineering, Jadavpur University; Secretary, IEEE Kolkata Section.
• Dr. Suparna Kar Chowdhury — Professor, Department of Electrical Engineering, Jadavpur University; Former Chair, IEEE Kolkata Section.
• Dr. Manjunatha Mahadevappa — Professor, Department of Medical Science and Technology, IIT Kharagpur, and Senior Member of IEEE EMBS.
• Dr. Sudip Kundu — Professor, Department of Biophysics, Molecular Biology and Bioinformatics, University of Calcutta.`,
    date: '2026-10-12',
    venue: 'Institute of Engineering & Management (IEM), Kolkata — IEEE Kolkata Section',
    imageUrl: '/ieee-embs-installation-2026-1.jpeg',
    images: [
      '/ieee-embs-installation-2026-1.jpeg',
      '/ieee-embs-installation-2026-2.jpeg',
      '/ieee-embs-installation-2026-3.jpeg',
      '/ieee-embs-installation-2026-4.jpeg',
      '/ieee-embs-installation-2026-5.jpeg',
      '/ieee-embs-installation-2026-6.jpeg',
    ],
  },
  {
    id: 'when-friction-has-a-memory-2026',
    category: 'Talk',
    title: 'Popular Lecture: “When Friction has a Memory” — Dr. Mattia Coccolo',
    description: `IIFR Lab, IIC IEM and the Department of Basic Science and Humanities presented a popular lecture, “When Friction has a Memory”, as part of the Foreign Lecture Series from CoE IIFR Lab, Department of Basic Science and Humanities.

Speaker: Dr. Mattia Coccolo, Associate Professor of Applied Physics at Universidad Rey Juan Carlos (URJC), Madrid, Spain.

About the Talk: Friction is not just a force opposing motion — it can also “remember” its past. In this engaging lecture, Dr. Mattia Coccolo explored the fascinating concept of memory effects in friction, their physical origins, and their implications in modern science and engineering. The talk was accessible to a broad audience and highlighted how this phenomenon connects fundamental physics with real-world applications.

Topics: Tribology, Memory Effects, Materials Physics, Nonlinear Dynamics, Real-World Applications.

Date & Time: 30th September 2026, 7:30 PM to 8:30 PM
Mode: Online through Google Meet
Seats: Limited, only 130
Certificate: Certificate for all participants (will carry MAR points)

Organizers: Dr. Somnath Roy, Dr. Chandan Adhikari, Dr. Ranabir Banik, Dr. Sukhendu Sadhukhan
Organizing Chair: Dr. Prabir Kumar Das`,
    date: '2026-09-30',
    imageUrl: '/when-friction-has-a-memory-2026-1.jpeg',
    images: [
      '/when-friction-has-a-memory-2026-1.jpeg',
      '/when-friction-has-a-memory-2026-2.jpeg',
      '/when-friction-has-a-memory-2026-3.jpeg',
      '/when-friction-has-a-memory-2026-4.jpeg',
    ],
    linkUrl: '/when-friction-has-a-memory-2026-flyer.jpeg',
  },
  {
    id: 'drone-workshop-2026',
    category: 'Workshop',
    title: 'Decode the Drone: Anatomy, Electronics & Flight',
    description: `IIFR Lab, IIC IEM and the Department of Basic Science and Humanities presented a hands-on workshop exclusively for B.Tech. first-year students: Decode the Drone: Anatomy, Electronics & Flight.

Understand how individual components work together to achieve stable and controlled flight.

Topics: Drone Components and Their Functions; Electronics & Flight Control; Assembly & System Integration; Principles of Stable Flight.

Instructor: Pratim Chaterjee, DGCA approved Drone Instructor, Former U.A.V. Engineer and Instructor.

Date & Time: 5th October 2026 (Monday), 4:30 PM to 5:30 PM
Venue: CII Auditorium, IEM Management House
Seats: Limited, only 100
Certificate: Certificate for all participants (will carry MAR points)
Mandatory requirement: Participants needed to bring their own laptop.

Organizers: Dr. Chandan Adhikari, Dr. Sukhendu Sadhukhan, Dr. Somnath Roy, Dr. Ranabir Banik, Shivam Roy Chowdhury
Student Coordinators: Soham Mondal, Aitihya Mondal, Debasish Mohanty, Sounak Chakraborty, Subham Giri
Organizing Chair: Dr. Prabir Kumar Das`,
    date: '2026-10-05',
    imageUrl: '/drone-workshop-2026-1.jpeg',
    images: [
      '/drone-workshop-2026-1.jpeg',
      '/drone-workshop-2026-2.jpeg',
      '/drone-workshop-2026-3.jpeg',
      '/drone-workshop-2026-4.jpeg',
      '/drone-workshop-2026-5.jpeg',
      '/drone-workshop-2026-6.jpeg',
    ],
    linkUrl: '/drone-workshop-2026-flyer.jpeg',
  },
  {
    id: 'arduino-workshop-2026',
    category: 'Workshop',
    title: 'Know Your Arduino Kit — Explore, Experiment & Create',
    description: `IIFR Lab, IIC IEM and the Department of Basic Science and Humanities presented a hands-on workshop exclusively for B.Tech. first-year students: Know Your Arduino Kit — Explore, Experiment & Create.

Ideas to Innovation. Build. Learn. Experiment. Create. Small Projects, Big Possibilities.

Date & Time: 23rd September 2026, 4:30 PM to 5:30 PM
Venue: CII Auditorium, IEM Management House
Instructor: Dr. Sukhendu Sadhukhan, Ph.D. (Physics)
Seats: Limited, only 100
Certificate: Certificate for all (will carry MAR points)
Mandatory requirement: Participants needed to bring their own laptop and the Arduino Kit given by IEM.

Organizers: Dr. Chandan Adhikari, Dr. Ranabir Banik, Dr. Somnath Roy
Organizing Chair: Dr. Prabir Kumar Das

Learn. Experiment. Innovate. Build a Brighter Tomorrow. From Students to Innovators.`,
    date: '2026-09-23',
    imageUrl: '/arduino-workshop-2026-1.jpeg',
    images: [
      '/arduino-workshop-2026-1.jpeg',
      '/arduino-workshop-2026-2.jpeg',
      '/arduino-workshop-2026-3.jpeg',
      '/arduino-workshop-2026-4.jpeg',
      '/arduino-workshop-2026-5.jpeg',
      '/arduino-workshop-2026-6.jpeg',
    ],
    linkUrl: '/arduino-workshop-2026-flyer.jpg',
  },
  {
    id: 'business-plan-competition-2026',
    category: 'Competition',
    title: 'Inter Section Business Plan Competition — Green Business for a Sustainable Future',
    description: `IIC IEM, CoE IIFR Lab and the Department of Basic Science and Humanities presented the Inter Section Business Plan Competition.

Theme: Green Business for a Sustainable Future (renewable energy, sustainable products, green manufacturing).

Only one submission per section. A maximum of 4 representatives per section may present during the final presentation.

Date of submission start: 15th August 2026
Last date of submission: 19th August 2026
Final presentation: 20th August 2026 (Thursday)
Presentation time: 7 minutes (5 minutes + 2 minutes)
Result announcement: 21st August 2026

Award and certificate for the Winner, 1st and 2nd Runner Up.

Organizers: Dr. Subhamoy Banerjee, Dr. Chandan Adhikari, Dr. Ranabir Banik, Dr. Somnath Roy, Dr. Sukhendu Sadhukhan
Organizing Chair: Dr. Prabir Kumar Das
Student Coordinators: Debasish Mohanty, Subarna De, Soumik Nath, Ankush Banerjee, Sounak Chakrabarty, Suchona Saha

Innovate Today. Build Tomorrow. Inspire Sustainable Change.`,
    date: '2026-08-20',
    imageUrl: '/business-plan-competition-2026-1.jpeg',
    images: [
      '/business-plan-competition-2026-1.jpeg',
      '/business-plan-competition-2026-2.jpeg',
      '/business-plan-competition-2026-3.jpeg',
      '/business-plan-competition-2026-4.jpeg',
      '/business-plan-competition-2026-5.jpeg',
    ],
    linkUrl: '/business-plan-competition-2026-flyer.jpeg',
  },
  {
    id: 'laser-engraving-workshop-2026',
    category: 'Workshop',
    title: 'Hands-On Workshop on Digital Manufacturing through Laser Engraving',
    description: `Learn. Design. Engrave. Create.

CoE IIFR Lab, IIC IEM and the Department of Basic Science and Humanities presented a hands-on workshop on Digital Manufacturing through Laser Engraving.

Date: 10th August 2026 to 14th August 2026
Time: 4:30 PM to 5:30 PM
Venue: IIFR Lab, IEM Management House
Seats: Only 25 (selected based on previous skills and Class 12 marks)
Registration: Free (register by 6th August 2026; no submission after that)

Certificate for all (will carry MAR points and will make your CV strong).
Certificate eligibility: 100% attendance in all 5 sessions and 80% marks in the hands-on exam at the end of the workshop.

Instructor: Dr. Sukhendu Sadhukhan, Ph.D.; Physics
Organizers: Dr. Chandan Adhikari, Dr. Ranabir Banik, Dr. Somnath Roy
Organizing Chair: Dr. Prabir Kumar Das
Student Coordinators: Debasish Mohanty, Subarna De, Soumik Nath

Transform Ideas into Reality with Precision and Creativity.`,
    date: '2026-08-10',
    imageUrl: '/Laser%20Engraving%20Workshop5.jpeg',
    images: [
      '/Laser%20Engraving%20Workshop5.jpeg',
      '/Laser%20Engraving%20Workshop2.jpeg',
      '/Laser%20Engraving%20Workshop3.jpeg',
      '/Laser%20Engraving%20Workshop4.jpeg',
      '/Laser%20Engraving%20Workshop1.jpeg',
    ],
    linkUrl: '/Laser%20Engraving%20Workshop.jpeg',
  },
  {
    id: 'photography-art-submission-portal-2026',
    category: 'Photography and Art',
    title: 'Photography and Art — রেখায়, আলোয় দুর্গা (Online Submission Portal)',
    description: `Welcome to the online submission portal for “রেখায়, আলোয় দুর্গা”, a Durga Puja-themed photography and drawing competition organized by the Department of Basic Science and Humanities (BSH), Institute of Engineering & Management (IEM), Kolkata.

Students are invited to express their creativity through photographs and artwork inspired by the colours, traditions, emotions, and artistic beauty of Durga Puja.

Capture the moments. Create the art. Celebrate Maa Durga.`,
    date: '2026-10-08',
    imageUrl: '/painting-contest-2026-1.jpeg',
    linkUrl: 'https://chalchitra-competiti-wera.bolt.host/#gallery',
    linkLabel: 'Open Submission Portal & Gallery',
  },
  {
    id: 'futurex-design-challenge-2026',
    category: 'Competition',
    title: 'FutureX Design Challenge 2026',
    description: `Get ready to Imagine Today. Design Tomorrow. CoE IIFR Lab, IIC IEM, and the Department of Basic Science & Humanities invite students to participate in the FutureX Design Challenge: Design Futuristic Products Using Generative AI.

Choose a real-world challenge from exciting themes including Smart Healthcare, Future Transportation, Sustainable Agriculture, Smart Education, Clean Energy, Climate Resilience, Robotics, Smart Cities, Disaster Management, and AI for Persons with Disabilities, and use Generative AI to design an innovative futuristic product.

Registration: Free
Benefits: Certificates for all participants (carrying MAR Points), funding opportunities for the Top 10 ideas, and special recognition.
Submission Deadline: 31st July 2026 | Result: 7th August 2026
Mode: Online

Organizing Chair: Dr. Prabir Kumar Das
Organizers: Dr. Chandan Adhikari, Dr. Ranabir Banik, Dr. Somnath Roy & Dr. Sukhendu Sadhukhan

Scan the QR code on the flyer to register and submit your idea. For any queries or assistance, students may contact the IIFR Lab after 4:15 PM.`,
    date: '2026-08-07',
    imageUrl: '/futurex-design-challenge-2026.jpeg',
    linkUrl: '/futurex-design-challenge-2026.jpeg',
  },
  {
    id: 'japanese-class-2026',
    category: 'Class',
    title: 'Japanese Class — Online',
    description: `Learn Japanese. Explore Opportunities. Build Your Global Future.

Commencing from 6th August 2026.

For: B.Tech 1st Year Students
Mode: Online (Live Sessions)
Language: Japanese (Beginner Level)
More details regarding schedule will be shared soon.

Why Learn Japanese?
- Enhance communication skills for global opportunities
- Open doors to career and higher education in Japan
- Experience a rich culture and unique way of thinking
- Build confidence and stand out in a global world

Course Instructor: Dr. Tetsuya Takeno, Konan University, Japan

Embrace a new language. Empower your future! All B.Tech 1st Year Students are encouraged to join. Stay tuned for updates!`,
    date: '2026-08-06',
    imageUrl: '/japanese-class-2026.jpeg',
    linkUrl: '/japanese-class-2026.jpeg',
  },
  {
    id: 'badminton-tournament-2026',
    category: 'Competition',
    title: 'Badminton Tournament',
    description: `Intra College Badminton Competition 2026, organized by IEM-UEM Group, held on 4th October 2026 (Sunday).`,
    date: '2026-10-04',
    imageUrl: '/badminton-tournament-2026-1.jpeg',
    images: ['/badminton-tournament-2026-1.jpeg', '/badminton-tournament-2026-2.jpeg'],
    linkUrl: '',
  },
  {
    id: 'industry-visit-bose-institute-2026',
    category: 'Industry Visit',
    title: 'Industry Visit at Bose Institute, Salt Lake',
    description: `The Department of Basic Science and Humanities, IEM Salt Lake Campus, in association with the IEM - AIP Society of Physics Students Chapter, is pleased to announce the successful completion of an Academic Visit to Bose Institute, Salt Lake Campus, on 29th September 2026.`,
    date: '2026-09-29',
    imageUrl: '/industry-visit-bose-institute-2026-cover.jpeg',
    images: [
      '/industry-visit-bose-institute-2026-cover.jpeg',
      '/industry-visit-bose-institute-2026-1.jpeg',
      '/industry-visit-bose-institute-2026-2.jpeg',
      '/industry-visit-bose-institute-2026-3.jpeg',
    ],
    linkUrl: '',
  },
  {
    id: 'research-scholar-conclave-2026',
    category: 'Talk',
    title: 'Research Scholar Conclave on Science and Engineering (IEMRSC 2026)',
    description: `The Research Scholar Conclave on Science and Engineering (IEMRSC 2026), First Edition, was held on 22 August 2026 at the Institute of Engineering & Management, Salt Lake Campus. The conclave provided a platform for researchers, academicians and young researchers to share ideas and discuss developments in science and engineering through invited lectures, contributed paper presentations, technical sessions and a workshop. More than 250 participants joined in online mode.`,
    date: '2026-08-22',
    imageUrl: '/research-scholar-conclave-2026-cover.jpeg',
    images: [
      '/research-scholar-conclave-2026-cover.jpeg',
      '/research-scholar-conclave-2026-1.jpeg',
      '/research-scholar-conclave-2026-2.jpeg',
    ],
    linkUrl: '',
  },
  {
    id: 'mental-health-awareness-rally-2026',
    category: 'Social',
    title: 'Mental Health Awareness Rally 2026 — IEM United for Wellness',
    description: `On the occasion of World Mental Health Day, a Mental Health Awareness Rally, "IEM United for Wellness," was organized on 7th October 2026 at Sector V, Salt Lake. The rally witnessed the enthusiastic participation of more than 1,500 students, along with faculty members and staff members, making it a remarkable initiative towards promoting mental health awareness and well-being.

The rally, with a cultural program, was organized by the Department of Basic Science and Humanities, IEM, Kolkata, Salt Lake (School of UEM, Kolkata), in association with the Lions Club of Kolkata IEM, Lions Club of Kolkata Saltlake IEM, and Rotary Club of Salt Lake Silicon Valley.

"Breaking the Silence, Building the Culture of Care."`,
    date: '2026-10-07',
    imageUrl: '/mental-health-rally-2026-photo-1.jpeg',
    images: [
      '/mental-health-rally-2026-photo-1.jpeg',
      '/mental-health-rally-2026-photo-2.jpeg',
      '/mental-health-rally-2026-photo-7.jpeg',
      '/mental-health-rally-2026-photo-6.jpeg',
      '/mental-health-rally-2026-photo-4.jpeg',
      '/mental-health-rally-2026-photo-5.jpeg',
      '/mental-health-rally-2026-photo-3.jpeg',
      '/mental-health-rally-2026.jpeg',
    ],
    linkUrl: '',
  },
  {
    id: 'voices-for-the-voiceless-2026',
    category: 'Talk',
    title: 'Voices for the Voiceless: Campus for Compassion',
    description: `Celebrating International Animal Welfare Day — "Voices for the Voiceless: Campus for Compassion," organized by the Department of Basic Science and Humanities, IEM Saltlake Campus. Because every life matters...

Speaker: Ms. Alokparna Sengupta, Managing Director, Humane World for Animals India; Member, State Board of Wildlife, Telangana.

Date: 5th October 2026
Time: 4:15 PM – 5:15 PM
Mode: Online

Faculty Coordinators: Dr. Sayani Das, Dr. Sangeeta Das, Dr. Saheli Sengupta, Dr. Anisha Purkait`,
    date: '2026-10-05',
    imageUrl: '/voices-for-the-voiceless-2026.jpeg',
    linkUrl: '/voices-for-the-voiceless-2026.jpeg',
  },
  {
    id: 'smart-maker-fest-2026',
    category: 'Fest',
    title: 'SMART MAKER FEST 2026',
    description: `SMART MAKER FEST 2026 was held on 3rd & 4th October 2026 at IEM Management House, Kolkata. Organised by the Institute of Engineering & Management (IEM) and University of Engineering and Management, Kolkata (UEM), Salt Lake, in association with SMART Society, the two-day fest brought technology, creativity and entrepreneurship under one roof.

Highlights included a maker exhibition, an eight-hour hackathon, robotics and drone workshops, a science and technology quiz, and a range of industry and culture events, with participation from students and young innovators. The fest was supported by Lions Club of Kolkata IEM, Lions Club of Kolkata Saltlake IEM and Rotary Club of Salt Lake Silicon Valley.

Media coverage: Puber Kalom (4 October 2026) and Outlook Business (5 October 2026).`,
    date: '2026-10-03',
    imageUrl: '/smart-maker-fest-2026-1.jpeg',
    images: [
      '/smart-maker-fest-2026-1.jpeg',
      '/smart-maker-fest-2026-2.jpeg',
      '/smart-maker-fest-2026-3.jpeg',
      '/smart-maker-fest-2026-4.jpeg',
      '/smart-maker-fest-2026-5.jpeg',
      '/smart-maker-fest-2026-6.jpeg',
    ],
    linkUrl: '',
  },
  {
    id: 'tedx-iem-salt-lake-2026',
    category: 'Talk',
    title: 'TEDx IEM Salt Lake 2026 — CTRL + U: Loneliness in the Era of AI',
    description: `TEDx IEM Salt Lake 2026 was held on 30th September 2026, with the theme "CTRL + U: Loneliness in the Era of AI."

Speakers:
1. Satish Reddy Eadala, Development Director, Electronic Arts (EA)
2. Chaiti Ghoshal, Film & Theatre Actor
3. Lagnajita Chakraborty, Playback Singer
4. Bhakt Bhagwat, Spiritual Orator and one of the youngest TEDx speakers in the world
5. Dr. Kunal Sarkar, Cardiovascular & Thoracic Surgeon
6. Prof. Dr. Suman Chakraborty, Director, IIT Kharagpur
7. Prof. Dr. Satyajit Chakrabarti, Vice Chancellor, UEM Kolkata`,
    date: '2026-09-30',
    imageUrl: '/tedx-iem-salt-lake-2026-1.jpeg',
    images: [
      '/tedx-iem-salt-lake-2026-1.jpeg',
      '/tedx-iem-salt-lake-2026-2.jpeg',
      '/tedx-iem-salt-lake-2026-3.jpeg',
      '/tedx-iem-salt-lake-2026-4.jpeg',
      '/tedx-iem-salt-lake-2026-5.jpeg',
      '/tedx-iem-salt-lake-2026-6.jpeg',
    ],
    linkUrl: '',
  },
  {
    id: 'painting-photography-contest-2026',
    category: 'Competition',
    title: 'Painting & Photography Contest — Rekhay Aloy Durga',
    description: `Organized by the Department of Basic Science and Humanities, Institute of Engineering & Management, Kolkata.

Rekhay Aloy Durga: Where Tradition Meets AI — Art, Lens & Intelligence in One Frame.

Categories:
- Live Painting (Sketch or Colour)
- Photography (Mobile/DSLR)

Sub-themes:
1. Durga Beyond the Idol
2. Colours of Durgotsav
3. Kolkata in the Puja
4. The Hands Behind Durgotsav
5. Green Durgotsav

An excellent opportunity to appear in the Departmental Magazine. Awards will be given to the winners. MAR points will be provided for participation.

Event Date: 8 October 2026
Time: 4:15 PM

Faculty Coordinators: Dr. Soumyabrata Goswami, Dr. Dibyasree Choudhury, Dr. Sangeeta Das, Dr. Sayani Das, Dr. Souvik Mondal`,
    date: '2026-10-08',
    imageUrl: '/painting-contest-2026-1.jpeg',
    images: [
      '/painting-contest-2026-1.jpeg',
      '/painting-contest-2026-2.jpeg',
      '/painting-contest-2026-3.jpeg',
      '/painting-contest-2026-4.jpeg',
      '/painting-contest-2026-5.jpeg',
      '/painting-contest-2026-6.jpeg',
      '/painting-contest-2026-flyer.jpeg',
    ],
    linkUrl: '',
  },
];
